import { environmentsSchema } from 'utils';
import { get } from './call';

export const getEnvironments = async () => {
  const { res } = await get('environments', environmentsSchema.getEnvironmentsSchema);
  return res;
};
